var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 12,
    viewBox: "0 0 72 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 6.00001L62 0.226503L62 11.7735L72 6.00001ZM-8.74228e-08 7L63 7.00001L63 5.00001L8.74228e-08 5L-8.74228e-08 7Z",
    fill: "#f0f0f0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHorizontal);
export default __webpack_public_path__ + "static/media/arrow-horizontal.d01a71439621b59d5e1a57d650a90906.svg";
export { ForwardRef as ReactComponent };